import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export const EvaluationsMenuSkeleton: React.FC = () => {
  return (
    <Stack alignItems='stretch' alignContent='center'>
      {[...Array(3)].map((_, i) => (
        <Box
          sx={{
            width: '100%',
            flex: 1,
            alignSelf: 'center',
          }}
          key={i}
        >
          <Skeleton variant='rectangular' height={40} sx={{ marginBottom: '20px' }} />
        </Box>
      ))}
    </Stack>
  );
};

export default EvaluationsMenuSkeleton;
